import React from 'react';
import KabobMenu from 'Views/Page/Content/Templates/WhatIfTemplate/Components/KabobMenu'; // TODO: Move this outside of what if
import KabobMenuItem from 'Views/Page/Content/Templates/WhatIfTemplate/Components/KabobMenu/KabobMenuItem'; // TODO: Move this outside of what if
import PropTypes from 'prop-types';
import { useRightSidebarContext } from 'Views/Page/Content/RightSidebar/RightSidebarContext';

const AdditionalActionsMenu = ({ resource }) => {
  const { loadRightSidebarCollectionLink } = useRightSidebarContext();

  const linkButtonRelationships = resource.relationships().list().filter((r) => {
    return r.meta('relationshipType') === 'linkButton';
  });

  if (linkButtonRelationships.length === 0) {
    return null;
  }

  return (
    <KabobMenu>
      {linkButtonRelationships.map((rel) => {
        return (
          <KabobMenuItem
            key={rel.id()}
            label={rel.meta('prompt')}
            onClick={() => {
              loadRightSidebarCollectionLink(rel.link('related'));
            }}
          />
        );
      })}
    </KabobMenu>
  );
};

AdditionalActionsMenu.propTypes = {
  resource: PropTypes.object.isRequired,
};

export default AdditionalActionsMenu;
